import { createContext } from 'react';

import type { TimeseriesChartConfigProperties } from '../types/timeseries-config.js';

/**
 * @internal
 */
export const TimeseriesChartConfigContext = createContext<
  TimeseriesChartConfigProperties | string
>({});

/**
 * Provider for the TimeseriesChart API config that can be shared across charts
 * @public
 */
export const TimeseriesChartConfig = TimeseriesChartConfigContext.Provider;
